import { api } from "./base";
/**
 * Отправляет метрику пользователя
 * @param data - Данные метрики (telegram_id и action)
 */
export const sendUserMetric = async (data) => {
    try {
        await api.post("/api/v1/public/users/profile/submit-action", data);
    }
    catch (error) {
        // Логируем ошибку, но не прерываем выполнение
        console.error("Error sending user metric:", error);
    }
};
